import React, { useEffect, useState } from 'react'
import Title from '../../../components/panelcontrols/paneltitle'
import OrderTable from './orderTable'
import OrderStatusSelector  from './orderStatusSelector'
import OrderFunctions from '../orders/list/functions'
import './index.css'

const Index = () => {
  const [selectedStatus,setSelectedStatus] = useState(0);
  const [orderList,setOrderList] = useState([]);
  const [page,setPage] = useState(1);
  const [paginationInfo,setPaginationInfo] = useState({ pages: 1, total: 0 });
  const [searchTerm,setSearchTerm] = useState('');
  const [debouncedSearch,setDebouncedSearch] = useState('');
  const limit = 20;

  // Starts true so the first paint is a shimmer rather than "No data available".

  // apiGetList guarantees applyList runs even on failure, so this always clears.

  const [loading,setLoading] = useState(true);

  const applyList = (data)=>{

    setOrderList(data);

    setLoading(false);

  };

  useEffect(()=>{
    const t = setTimeout(()=>{
      setDebouncedSearch(searchTerm);
      setPage(1);
    },350);
    return ()=>clearTimeout(t);
  },[searchTerm]);

  useEffect(()=>{ setPage(1); },[selectedStatus]);

  useEffect(()=>{
    if(selectedStatus === 0){
      OrderFunctions.Get(applyList, setPaginationInfo, page, limit, debouncedSearch);
    }
    else{
      OrderFunctions.GetByStatus(selectedStatus, applyList, setPaginationInfo, page, limit, debouncedSearch);
    }
  },[selectedStatus, page, debouncedSearch])

  return (
    <div className='labadmin_dashboard_container'>
      <Title Value={'Dashboard'}/>
      <OrderStatusSelector selectedStatus={selectedStatus} setSelectedStatus={setSelectedStatus}/>
      <OrderTable List={orderList} loading={loading} search={searchTerm} onSearch={setSearchTerm}/>
      <div style={{display:'flex',justifyContent:'center',alignItems:'center',gap:'12px',padding:'16px'}}>
        <button
          onClick={()=>setPage(p=>p-1)}
          disabled={page<=1}
          style={{padding:'6px 16px',cursor:page<=1?'not-allowed':'pointer',opacity:page<=1?0.5:1,borderRadius:'4px',border:'1px solid #ccc'}}>
          Previous
        </button>
        <span style={{fontSize:'14px'}}>Page {page} of {paginationInfo.pages||1} &nbsp;|&nbsp; Total: {paginationInfo.total||0}</span>
        <button
          onClick={()=>setPage(p=>p+1)}
          disabled={page>=(paginationInfo.pages||1)}
          style={{padding:'6px 16px',cursor:page>=(paginationInfo.pages||1)?'not-allowed':'pointer',opacity:page>=(paginationInfo.pages||1)?0.5:1,borderRadius:'4px',border:'1px solid #ccc'}}>
          Next
        </button>
      </div>
    </div>
  )
}

export default Index
